import { render, staticRenderFns } from "./LimitExtensionTable.vue?vue&type=template&id=1a97bf3c"
import script from "./LimitExtensionTable.vue?vue&type=script&lang=js"
export * from "./LimitExtensionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports